export const ICON_SIZE_TO_CONTAINER_SIZE = 0.58;
